export default "__VITE_PUBLIC_ASSET__1089b0a1__"